<template>
  <div class="min-h-screen bg-white flex">
    <!-- Left Side - Image/Branding (Desktop) -->
    <div class="hidden lg:flex lg:w-1/2 bg-cover bg-center relative" style="background-image: url('https://images.unsplash.com/photo-1556742049-0cfed4f7a07d?w=1200')">
      <div class="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-blue-700/80"></div>
      <div class="relative z-10 flex flex-col justify-between h-full p-12 text-white">
        <div>
          <a href="/" class="flex items-center gap-2.5">
            <div class="w-10 h-10 bg-white rounded-xl flex items-center justify-center">
              <span class="text-blue-600 font-bold text-lg">R</span>
            </div>
            <span class="text-xl font-bold">Fluxreload</span>
          </a>
        </div>
        <div>
          <h1 class="text-4xl font-bold mb-4">Rejoignez la communauté</h1>
          <p class="text-blue-100 text-lg">Accédez aux meilleures cartes cadeaux en Afrique de l'Ouest</p>
        </div>
      </div>
    </div>

    <!-- Right Side - Registration Form -->
    <div class="flex-1 flex items-center justify-center p-6 md:p-12 overflow-y-auto">
      <div class="w-full max-w-md">
        <!-- Mobile Logo -->
        <div class="lg:hidden text-center mb-8">
          <a href="/" class="inline-flex items-center gap-2.5">
            <div class="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center">
              <span class="text-white font-bold text-lg">R</span>
            </div>
            <span class="text-lg font-bold text-blue-800">Fluxreload</span>
          </a>
        </div>

        <h1 class="text-2xl font-bold text-gray-900 mb-2">Inscription</h1>
        <p class="text-gray-500 mb-8">Créez votre compte pour commencer</p>

        <form
          class="space-y-4"
          v-bus:EVENTS.USER.REGISTER.submit.prevent
          v-redirect-on="{
            event: $constants.EVENTS.USER.REGISTER_SUCCESS,
            to: '/profile'
          }"
        >
          <!-- Nom et Prénom -->
          <div class="border border-gray-300 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-600 focus-within:border-blue-600 transition-all">
            <div class=" grid grid-cols-2">
              <input
                name="firstName"
                type="text"
                required
                class="flex-1 px-4 py-3 border-r border-gray-300 outline-none transition-all"
                placeholder="Prénom"
              />
              <input
                name="lastName"
                type="text"
                required
                class="flex-1 px-4 py-3 outline-none transition-all"
                placeholder="Nom"
              />
            </div>
          </div>

          <!-- Téléphone -->
          <div class="border border-gray-300 rounded-xl  focus-within:ring-2 focus-within:ring-blue-600 focus-within:border-blue-600 transition-all">
            <div class="flex">
              <Listbox v-model="selectedCountry" as="div" class="relative flex-1 max-w-[110px]">
                <ListboxButton class="w-full h-full px-3 py-3 border-r border-gray-300  outline-none flex items-center gap-2">
                  <img v-if="selectedCountry" :src="selectedCountry.flag" class="w-5 h-4 object-cover rounded-sm" />
                  <span class="flex-1 text-left text-sm">{{ selectedCountry?.code || '+' }}</span>
                  <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                  </svg>
                </ListboxButton>
                <ListboxOptions class="absolute z-50 mt-1 max-h-60 w-auto min-w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-sm">
                  <ListboxOption
                    v-for="country in countries"
                    :key="country.code"
                    :value="country"
                    class="relative cursor-pointer select-none py-2 pl-3 pr-9 hover:bg-gray-100 flex items-center gap-2 whitespace-nowrap"
                  >
                    <img :src="country.flag" class="w-5 h-4 object-cover rounded-sm" />
                    <span class="font-medium">+{{ country.code }}</span>
                    <span class="text-gray-500 ml-1">{{ country.name }}</span>
                  </ListboxOption>
                </ListboxOptions>
              </Listbox>
              <input
                name="phoneNumber"
                type="tel"
                required
                class="flex-1 px-4 py-3 outline-none transition-all"
                placeholder="Numéro de téléphone"
              />
              <input
                name="phonePrefix"
                type="hidden"
                :value="selectedCountry?.code || ''"
              />
            </div>
          </div>

          <!-- Email -->
          <div class="border border-gray-300 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-600 focus-within:border-blue-600 transition-all">
            <input
              name="email"
              type="email"
              required
              class="w-full px-4 py-3 outline-none transition-all"
              placeholder="Email"
            />
          </div>

          <!-- Mot de passe -->
          <div class="border border-gray-300 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-600 focus-within:border-blue-600 transition-all">
            <input
              name="password"
              type="password"
              required
              class="w-full px-4 py-3 outline-none transition-all"
              placeholder="Mot de passe"
            />
          </div>

          <!-- Cases à cocher -->
          <label class="flex items-start gap-3 cursor-pointer">
            <input
              name="termOfUse"
              type="checkbox"
              required
              class="mt-1 w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
            />
            <span class="text-sm text-gray-600">
              J'accepte les
              <a
                href="https://web.{lacasaeBettingServiceName}.com/cgu"
                target="_blank"
                class="text-blue-600 hover:underline font-medium"
              >
                conditions d'utilisation
              </a>
            </span>
          </label>

          <!-- Submit button -->
          <button
            type="submit"
            class="w-full py-3.5 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:shadow-lg hover:bg-blue-700 transition-all duration-200"
            :disabled="$stores?.user?.state?.loading"
          >
            <span v-if="$stores?.user?.state?.loading">Inscription...</span>
            <span v-else>S'inscrire</span>
          </button>
        </form>

        <!-- Sign in link -->
        <p class="text-center text-gray-600 mt-8">
          Déjà un compte ?
          <router-link to="/login" class="text-blue-600 font-semibold hover:underline">Connectez-vous</router-link>
        </p>

        <!-- Back to home -->
        <div class="text-center mt-6">
          <a href="/" class="inline-flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
            </svg>
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue';

const countries = [
  { code: '229', name: 'Bénin', flag: 'https://flagcdn.com/w40/bj.png' },
  { code: '228', name: 'Togo', flag: 'https://flagcdn.com/w40/tg.png' },
  { code: '225', name: "Côte d'Ivoire", flag: 'https://flagcdn.com/w40/ci.png' },
  { code: '226', name: 'Burkina Faso', flag: 'https://flagcdn.com/w40/bf.png' },
  { code: '223', name: 'Mali', flag: 'https://flagcdn.com/w40/ml.png' },
  { code: '221', name: 'Sénégal', flag: 'https://flagcdn.com/w40/sn.png' },
  { code: '241', name: 'Gabon', flag: 'https://flagcdn.com/w40/ga.png' },
  { code: '227', name: 'Niger', flag: 'https://flagcdn.com/w40/ne.png' }
];

const selectedCountry = ref(countries[0]);
</script>
